// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconPtsusde } from "../../../icons/mono/build/icon-ptsusde.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const PtsusdeIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconPtsusde.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  PtsusdeIcon.displayName = 'PtsusdeIcon';
}

export default PtsusdeIcon;